import React from "react"
import PropTypes from "prop-types"

import { useTranslation } from "react-i18next"

import Delete from "components/GenericViews/Delete"
import { reverse } from "utils/urls"

export default function AirlineInfantBookingFareDelete(props) {
  const { t } = useTranslation()

  return (
    <Delete
      modelName={t("Airline Infant Booking Fare")}
      endpoint={`/fares/airline-infant-fares/${props.match.params.id}/`}
      successRoute={reverse("airlineInfantBookingFareList")}
      errorRoute={reverse("airlineInfantBookingFareList")}
    />
  )
}

AirlineInfantBookingFareDelete.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
